import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React, { PureComponent, createRef } from 'react';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

var scrollToBottom = function scrollToBottom(el) {
  el.scrollTop = el.scrollHeight;
};

/**
 * `ConsoleOutput` component is used for showing dynamically updating data from console output.
 * @since 0.0.35
 */
var ConsoleOutput =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ConsoleOutput, _PureComponent);

  function ConsoleOutput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ConsoleOutput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ConsoleOutput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "rootRef", createRef());

    _defineProperty(_assertThisInitialized(_this), "prevScrollTop", 0);

    _defineProperty(_assertThisInitialized(_this), "autoscrollCancelled", false);

    _defineProperty(_assertThisInitialized(_this), "handleScroll", function () {
      var el = _this.rootRef.current;

      if (!el) {
        return;
      }

      if (el.scrollTop < _this.prevScrollTop) {
        _this.autoscrollCancelled = true;
      } else if (el.clientHeight + el.scrollTop >= el.scrollHeight) {
        _this.autoscrollCancelled = false;
      }
    });

    return _this;
  }

  _createClass(ConsoleOutput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var autoscroll = this.props.autoscroll;
      var el = this.rootRef.current;

      if (autoscroll && el) {
        scrollToBottom(el);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var autoscroll = this.props.autoscroll;
      var el = this.rootRef.current;

      if (autoscroll && el) {
        this.prevScrollTop = el.scrollTop;

        if (!this.autoscrollCancelled) {
          scrollToBottom(el);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          baseClassName = _this$props.baseClassName,
          className = _this$props.className,
          wide = _this$props.wide,
          cursor = _this$props.cursor,
          children = _this$props.children,
          autoscroll = _this$props.autoscroll,
          props = _objectWithoutProperties(_this$props, ["baseClassName", "className", "wide", "cursor", "children", "autoscroll"]);

      var onScroll = autoscroll ? this.handleScroll : undefined;
      return React.createElement("pre", _extends({
        className: classNames(baseClassName, _defineProperty({}, "".concat(baseClassName, "--wide"), wide), className),
        ref: this.rootRef,
        onScroll: onScroll
      }, props), children, cursor ? React.createElement("span", {
        className: "".concat(baseClassName, "__cursor")
      }) : null);
    }
  }]);

  return ConsoleOutput;
}(PureComponent);

_defineProperty(ConsoleOutput, "defaultProps", {
  baseClassName: "".concat(CLS_PREFIX, "console-output"),
  wide: false,
  cursor: false,
  autoscroll: true
});

export default ConsoleOutput;